\:host
    width: 100%
    flex-shrink: 0
.Spacer
    display: flex
    width: 100%
    margin: 0
    padding: 0
    flex-shrink: 0
.S
    height: 10px
.M
    height: 20px
.L
    height: 30px
.XL
    height: 50px
